import { z } from 'zod';
import { platformJsonValueSchema } from '../settings/platform-setting-definition.contract.js';
export const platformDomainEventNameSchema = z
    .string()
    .min(7)
    .max(160)
    .regex(/^[a-z][a-z0-9-]*(?:\.[a-z0-9-]+)+\.v[1-9][0-9]*$/);
export const platformDomainEventPayloadSchema = z.record(z.string(), platformJsonValueSchema);
const platformDomainEventInputObjectSchema = z.strictObject({
    eventName: platformDomainEventNameSchema,
    eventVersion: z.number().int().positive(),
    aggregateId: z.string().min(1).max(240),
    payload: platformDomainEventPayloadSchema,
    occurredAt: z.string().datetime({ offset: true }).optional(),
    causationId: z.string().uuid().nullable().default(null),
});
function eventNameVersionMatches(value) {
    return value.eventName.endsWith(`.v${value.eventVersion}`);
}
export const platformDomainEventInputSchema = platformDomainEventInputObjectSchema.refine(eventNameVersionMatches, { message: 'Event name version must match eventVersion.' });
export const platformDomainEventSchema = platformDomainEventInputObjectSchema.extend({
    eventId: z.string().uuid(),
    occurredAt: z.string().datetime({ offset: true }),
    tenantId: z.string().uuid(),
    actorId: z.string().uuid(),
    actorMembershipId: z.string().uuid(),
    correlationId: z.string().uuid(),
}).refine(eventNameVersionMatches, {
    message: 'Event name version must match eventVersion.',
});
export const platformOutboxLeaseSchema = z.strictObject({
    event: platformDomainEventSchema,
    attemptCount: z.number().int().positive(),
    leaseToken: z.string().uuid(),
    leaseExpiresAt: z.string().datetime({ offset: true }),
});
export const platformOutboxDeliveryStateSchema = z.enum([
    'pending',
    'leased',
    'published',
    'dead_letter',
]);
export const platformOutboxHealthSchema = z.strictObject({
    pendingCount: z.number().int().nonnegative(),
    leasedCount: z.number().int().nonnegative(),
    deadLetterCount: z.number().int().nonnegative(),
    expiredLeaseCount: z.number().int().nonnegative(),
    oldestPendingAgeSeconds: z.number().nonnegative().nullable(),
    oldestLeasedAgeSeconds: z.number().nonnegative().nullable(),
    lastPublishedAt: z.string().datetime({ offset: true }).nullable(),
});
export const platformOutboxBatchResultSchema = z.strictObject({
    claimedCount: z.number().int().nonnegative(),
    publishedCount: z.number().int().nonnegative(),
    retriedCount: z.number().int().nonnegative(),
    deadLetterCount: z.number().int().nonnegative(),
    lostLeaseCount: z.number().int().nonnegative(),
});
//# sourceMappingURL=platform-domain-event.contract.js.map